import tableWithCustomLinkDisplayText from './tableWithCustomLinkDisplayText.json';
import tableWithEntityDetailLinks from './tableWithEntityDetailLinks.json';
import tableWithHiddenColumn from './tableWithHiddenColumn.json';
import tableWithSparklines from './tableWithSparklines.json';
import tableWithCustomizedSparklines from './tableWithCustomizedSparklines.json';
import tableWithSparklineSortingSupport from './tableWithSparklineSortingSupport.json';
import tableWithCustomDataFormatting from './tableWithCustomDataFormatting.json';
import tableWithStringThresholds from './tableWithStringThresholds.json';
import tableWithNumberThresholds from './tableWithNumberThresholds.json';
import tableWithTag from './tableWithUikTag.json';
import tableWithCustomLinkPod from './tableWithCustomLinkPod.json';

export default [
  tableWithCustomLinkDisplayText,
  tableWithEntityDetailLinks,
  tableWithHiddenColumn,
  tableWithSparklines,
  tableWithCustomizedSparklines,
  tableWithSparklineSortingSupport,
  tableWithCustomDataFormatting,
  tableWithStringThresholds,
  tableWithNumberThresholds,
  tableWithTag,
  tableWithCustomLinkPod,
];
